import { Col, Container, Row } from "react-bootstrap";
import "./sparc/style.css";


export default function SparcCourse() {
    return (
    <Container className="portfolio justified-content">
        <br/>
        <br/>
	  <Row>
        
		<Col sm="12">
			<div align="center">
            
                <Row>
                    <Col sm="4"><img src={process.env.PUBLIC_URL+'/sparc/iitlogo.png'} style={{maxWidth:"100%"}}/></Col>
                    <Col sm="4"><img src={process.env.PUBLIC_URL+'/sparc/sparclogo.png'} style={{maxWidth:"100%"}}/></Col>
                    <Col sm="4"><img src={process.env.PUBLIC_URL+'/sparc/rmitlogo.png'} style={{maxWidth:"100%"}}/></Col>  
                </Row>
                
                <h5>4 Day Experiential Course</h5>
                
                <h6>Jointly organized by IIT Delhi & RMIT Melbourne</h6>
                
                <img src={process.env.PUBLIC_URL+'/sparc/symplogo.png'} style={{maxWidth:"15%"}}/>
                
                <h3 style={{marginTop:"5px"}}>Design as Situational & Relational: Working with People in Place</h3>
                
                <h6>17-20 March 2025</h6>
                
                <h6>Ideation Lounge, Research & Innovation Park, IIT Delhi</h6>
                
            </div>

            <br/>
            <p className="section-heading"><b>Introduction</b></p> 
            <p>Join us for an immersive experience in co-designing for social impact!</p>
            
            <ol>
                <li>Explore co-designing with people in their environments</li>
                <li>Challenge conventional design & methods for social impact</li>
                <li>Engage in hands-on, interdisciplinary collaboration</li>
                <li>Conclude with a showcase & storytelling session</li>
            </ol>

            

            <br/>

            
            <Row>
                <Col sm="12" md="6" style={{marginTop:"30px"}}>
                    <p className="section-heading"><b>Symposium Daily Schedule</b></p>
            <table className="schedule-table">
                <tbody>
                <tr>
                    <td>9:30 am - 1:30 pm</td>
                    <td>In-Person Session with Facilitators</td>
                </tr>
                <tr>
                    <td>2:30 pm - 5:30 pm </td>
                    <td>Group Work by Participants</td>
                </tr>
                <tr>
                    <td>5:30 pm - 6:15 pm</td>
                    <td>Online Debrief with Facilitators</td>
                </tr>
                </tbody>
            </table>
                </Col>
                <Col sm="12" md="6" style={{marginTop:"30px"}}>
                <p className="section-heading"><b>Call for Participation</b></p>
                    <img src={process.env.PUBLIC_URL+'/sparc/formqr2.png'} width="50%"/>
                </Col>
                
            </Row>

<br/>
            
            <p className="section-heading"><b>Course Videos</b></p>
            <Row>
                <Col sm="12" md="6">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/L3S-hh8Trek?si=ujczspzi9NQREcmv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="6">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/S_VO6Tr-9Gc?si=_XfxsDEGd2GIje8D" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="6">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/I9vH_ZEBLkk?si=0HpeBU-6Axcgl3dv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="6">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/5kKY875zl44?si=k_P_k_7q8LMvcU6Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
            </Row>

            <p className="section-heading"><b>Course Facilitators</b></p>
            <Row>
                <Col sm="12" md="2">
                    <img src={process.env.PUBLIC_URL+'/sparc/liam.jpg'} width="100%"/>
                </Col>
                <Col sm="12" md="4">
                    <p>
                        Prof Liam Fennessy<br/>		
                        RMIT Melbourne<br/>
                        <a href="mailto:liam.fennessy@rmit.edu.au">liam.fennessy@rmit.edu.au</a>
                    </p>
                </Col>

                <Col sm="12" md="2">
                    <img src={process.env.PUBLIC_URL+'/sparc/oliver.jpg'} width="100%" style={{border:"1px solid #ddd"}}/>
                </Col>
                <Col sm="12" md="4">
                    <p>
                        Prof James Oliver<br/>
                        RMIT Melbourne<br/>
                        <a href="mailto:j.oliver@rmit.edu.au">j.oliver@rmit.edu.au</a>
                    </p>
                </Col>
            </Row>

            <p className="section-heading"><b>Course Coordinators</b></p>
            <Row>
                <Col sm="12" md="2">
                    <img src={process.env.PUBLIC_URL+'/sparc/chariar.jpg'} width="100%"/>
                </Col>
                <Col sm="12" md="4">
                    <p>
                        Prof Vijayaraghavan M Chariar<br/>		
                        IIT Delhi<br/>
                        <a href="mailto:chariarv@iitd.ac.in">chariarv@iitd.ac.in</a>
                    </p>
                </Col>

                
            </Row>

        </Col>
    </Row>
        <br/>
        <br/>
</Container>
    );
}